export default __webpack_public_path__ + "static/media/data.b6c068e1.svg";